const config = {
  freshserviceDomain: "servicedesk.inspiredenergy.co.uk"
};

export default config;